const analytics = {
  "Live Mode": "Live mode",
  "Log Scale": "Log scale",
  Title: "Title",
  "Max Records to Display": "Max records to display",
  "Time Granularity": "Time granularity",
  "X-Axis": "X-axis",
  "Y-Axis": "Y-axis",
  "Chart Type": "Chart type",
  Filters: "Filters",
  "Group By": "Group by",
  "Order By": "Order by",
  Width: "Width",
  "Drag and drop fields to configure your chart.":
    "Drag and drop fields to configure your chart.",
  "Loading chart...": "Loading chart...",
  Preview: "Preview",
  "XY Charts": "XY charts",
  "Bar Chart": "Bar chart",
  "Line Chart": "Line chart",
  "Scatter Plot": "Scatter plot",
  "Radial Charts": "Radial charts",
  "Pie Chart": "Pie chart",
  "Donut Chart": "Donut chart",
  "Time Series Charts": "Time series charts",
  "Grouped Bar": "Grouped bar",
  "Stacked Bar": "Stacked bar",
  "Area Chart": "Area chart",
  Day: "Day",
  Month: "Month",
  Year: "Year",
  "Data Fields": "Data fields",
  "Chart Types": "Chart types",
  Order: "Order",
  "Layout Span": "Layout span",
  half_width: "Half width",
  full_width: "Full width",
  "Configure your chart": "Configure your chart",
  "Dynamic Filters": "Dynamic filters",
  Categories: "Categories",
  "Drop categories here": "Drop categories here",
  "Drop value here": "Drop value here",
  "Drop chart type here": "Drop chart type here",
  "Drop Label Field Here": "Drop label field here",
  "Drop Value Field Here": "Drop value field here",
  "Drop Chart Type Here": "Drop chart type here",
  "Drop X-Axis Field Here": "Drop X-axis field here",
  "Drop Y-Axis Field Here": "Drop Y-axis field here",
  "Add Filter": "Add filter",
  Sum: "Sum",
  Average: "Average",
  Count: "Count",
  Minimum: "Minimum",
  Maximum: "Maximum",
  Median: "Median",
  configure: "Configure",
  failed_to_fetch_chart_data: "Failed to fetch chart data",
  create_link: "Create Link",
  click_target_node: "Click target node",
  delete_node: "Delete Node",
  delete_link: "Delete Link",
  connections: "Connections",
  drag_to_create_node_click_to_select:
    "Drag fields to create nodes, click nodes to select them",
  you_do_not_have_any_charts_configured_yet:
    "You do not have any charts configured yet.",
  "Add visualization": "Add visualization",
  "Update Preview": "Update preview",
  last_sync_at: "Last synced at",
  syncs_daily_at: "- syncs daily at 07:00 AM",
  at_07_00_am: "07:00 AM CET",
};

export default analytics;
